import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { NotificationsBell } from './NotificationsBell';
import { ProfileAvatarLink } from './ProfileAvatarLink';
import { SearchInput } from '../ui/SearchInput';
import { getAppPageTitle } from '../../utils/mobileRouteHeader';
import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

/**
 * `ds/nav/top-bar--desktop` — altura 56, superfície de card com borda inferior,
 * título $type-display-stat à esquerda, espaçador elástico e, à direita,
 * pesquisa (220px), sino de notificações e avatar. Padding lateral $space-5 a
 * 768 e $space-6 a 1280 (overrides das instâncias de página no .pen).
 */
export function DesktopTopBar({ className }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const title = getAppPageTitle(pathname);

  const handleSearch = (event) => {
    event.preventDefault();
    const trimmed = query.trim();
    if (!trimmed) {
      navigate(paths.expenses);
      return;
    }
    navigate(`${paths.expenses}?search=${encodeURIComponent(trimmed)}`);
  };

  return (
    <header
      className={cn(
        'hidden h-14 shrink-0 items-center gap-space-3 border-b border-border bg-card px-space-5 md:flex lg:px-space-6',
        className,
      )}
    >
      <h1 className="shrink-0 font-display text-type-display-stat font-semibold tracking-tight text-foreground">
        {title}
      </h1>

      <div className="flex-1" aria-hidden />

      <form onSubmit={handleSearch} className="w-[220px] shrink-0" role="search">
        <SearchInput
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onClear={() => setQuery('')}
          placeholder={pt.nav.searchPlaceholder}
          aria-label={pt.nav.searchAriaLabel}
          inputClassName="py-space-2-5 text-type-body"
        />
      </form>

      <NotificationsBell />
      <ProfileAvatarLink />
    </header>
  );
}

export default DesktopTopBar;
